class GetPlansError extends Error {
  constructor(cause, url, props, code = 'GET_PLANS_ERROR') {
    super("Falha ao buscar planos");
    this.name = 'GetPlansError';
    this.code = code;
    this.cause = cause;
    this.url = url;
    this.props = props;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GetPlansError);
    }
  }
}

module.exports = GetPlansError;